import * as React from 'react';
import './index.scss';
import Rule from '../../../../web/hooks/rule';

const { useState } = React;

const Tab4: React.FC = () => (
  <div className="rule-content">
    <Rule url={'https://zt.huya.com/17621/pc/index.html'} />
  </div>
)

export default Tab4;